<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
  [fullScreen]="true">
  <span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
  </span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
    <!--begin::Page title-->
    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading">
          <svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_1246_5488)">
              <path
                d="M29.4039 6.27336C23.7017 5.61371 20.5709 3.99455 18.2138 0.504383C18.1038 0.348431 17.9583 0.221273 17.7895 0.133529C17.6207 0.0457841 17.4335 0 17.2436 0C17.0537 0 16.8665 0.0457841 16.6977 0.133529C16.529 0.221273 16.3835 0.348431 16.2734 0.504383C13.6544 3.94658 10.4284 5.63769 5.04761 6.27336C4.75725 6.30871 4.48997 6.45052 4.29676 6.67173C4.10354 6.89294 3.99792 7.17807 4.00003 7.47273V11.9704C4.00003 21.0016 9.10699 27.0105 16.5948 30.9564C16.784 31.0756 17.0026 31.1387 17.2257 31.1387C17.4489 31.1387 17.6675 31.0756 17.8567 30.9564C19.7614 29.6971 22.8565 28.054 24.4279 26.3988C26.3414 24.5316 27.8612 22.2944 28.8962 19.8214C29.9312 17.3483 30.4602 14.6903 30.4515 12.0064V7.46074C30.4507 7.16814 30.3437 6.88594 30.1508 6.66725C29.9578 6.44856 29.6922 6.30847 29.4039 6.27336ZM20.2375 26.6627L17.2257 28.5457C15.4231 27.5249 13.7035 26.3619 12.0831 25.0675C12.1958 24.3334 12.5164 23.6476 13.0062 23.0924C13.4961 22.5372 14.1345 22.1361 14.8449 21.9372C15.0544 21.8818 15.2449 21.7698 15.3959 21.6135C15.547 21.4571 15.6528 21.2621 15.702 21.0496C15.9639 20.0062 14.5116 19.5504 14.6663 18.5309V14.7769C14.6725 14.3081 14.8601 13.8602 15.1892 13.5286C15.5182 13.1971 15.9628 13.008 16.4282 13.0018H18.0472C18.5093 13.0112 18.9496 13.202 19.2742 13.5335C19.5988 13.8651 19.7822 14.3112 19.7852 14.7769V18.5309C19.9161 19.5624 18.4995 19.9942 18.7614 21.0376C18.8077 21.2509 18.9109 21.4473 19.0598 21.6058C19.2088 21.7643 19.3978 21.8789 19.6066 21.9372C20.321 22.1342 20.9623 22.5381 21.4511 23.0988C21.9399 23.6595 22.2547 24.3523 22.3565 25.0915C21.6976 25.6808 20.9885 26.2105 20.2375 26.6747V26.6627Z"
                fill="#265D91" />
            </g>
            <defs>
              <filter id="filter0_d_1246_5488" x="0" y="0" width="34.4531" height="39.1388" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1246_5488" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1246_5488" result="shape" />
              </filter>
            </defs>
          </svg>

          Notre compte
        </h1>

        <!--begin::Menu-->

      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a routerLink="/accueil" class="text-muted ">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted"><a routerLink="/notre-compte" class="text-muted">Notre Compte</a></li>
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <li class="breadcrumb-item text-muted">Changer offre</li>
        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
  <!--begin::Content container-->
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="card content-table">
      <!--begin::Card headeer-->

      <div class="card-body ">
        <div class="action-grid mb-5">
          <div class="title">
            <h4>Liste des abonnements </h4>
          </div>
          <div class="retour">
            <a routerLink="/notre-compte">Voir offre actuelle</a>
          </div>
        </div>
        <div class="container tools">
          <div id="kt_app_content" class="app-content flex-column-fluid">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-xxl">
              <!--begin::Pricing card-->
              <div id="kt_pricing">
                <!--begin::Card body-->
                <div class="card-body p-0">
                  <!--begin::Plans-->
                  <div class="d-flex flex-column">
                    <!--begin::Heading-->
                    <!--end::Heading--><!--begin::Nav group-->
                    <div class="mb-3 text-center">
                      <h1 class="mt-0 mb-0 fs-2hx fw-bold mb-5">Choisir votre offre</h1>
                    </div>
                    <!--end::Heading-->
                    <!--begin::Nav group-->
                    <div class="nav-group nav-group-outline mx-auto mb-15">
                      <button class="btn btn-color-gray-600 btn-active btn-active-secondary px-6 py-3 me-2"
                        (click)="changeOfferPerMonth()"
                        [ngStyle]="{'background-color': perMonth ? '#e0e0e0' : '#ffffff'}">
                        Mensuel
                      </button>
                      <button class="btn btn-color-gray-600 btn-active btn-active-secondary px-6 py-3"
                        (click)="changeOfferPerYears()"
                        [ngStyle]="{'background-color': perYears ? '#e0e0e0' : '#ffffff'}">
                        Annuel (-20%)
                      </button>
                    </div>
                    <!--end::Nav group-->
                    <!--begin::Row-->
                    <div class="row g-3">
                      <!-- Offer Columns -->
                      <div class="col-lg-4 col-12 d-flex" *ngFor="let offer of listOffer">
                        <div class="card w-100 h-100 d-flex flex-column" *ngIf="offer.id!=4 && offer.id!=5" [ngClass]="{'space-gold':offer.id === 3}">
                            <h4 class="gold-offre" *ngIf="offer.id === 3">Le plus populaire</h4>
                          <div
                            class="card-body d-flex flex-column flex-grow-1 justify-content-between text-justify p-4 rounded-3"
                            [ngClass]="{
                              'bg-active-offer': offer.id === active_subscription_plan_id,
                              'bg-pending-offer': pending_plan_id != null && offer.id === pending_plan_id,
                              'bg-white': offer.id !== active_subscription_plan_id && offer.id !== pending_plan_id,
                              'ffff':offer.id === 1
                            }">
                          
                            <!-- Heading -->
                            <h2 class="h2 text-dark mb-6 pt-4 fw-bold text-center">{{ offer.name }}</h2>
                            <p class="offre-description mb-3" *ngIf="offer.id === 1">
                             Les fonctionnalités essentielles pour digitaliser vos recrutements.
                            </p>
                            <p class="offre-description mb-3" *ngIf="offer.id === 2">
                              Accès aux outils clés pour gérer, évaluer et recruter efficacement.
                            </p>
                            <p class="offre-description mb-3" *ngIf="offer.id === 3">
                              Un accès total à toutes les fonctionnalités pour booster vos recrutements sans limite.
                            </p>
                          <!-- Price Display -->
                            <div class="text-center mb-4">
                              <div *ngIf="perMonth">
                                <span class="fs-4 fw-bold text-primary">{{ offer.monthly_price }}</span>
                                <span class="fs-6 fw-semibold opacity-75"> €/Mois</span>
                              </div>
                              <div *ngIf="perYears">
                                <span class="fs-4 fw-bold text-primary">{{ offer.annual_price }}</span>
                                <span class="fs-6 fw-semibold opacity-75"> €/An</span>
                                <div  *ngIf="offer.id === 1">
                                   <small >(82.5 €/Mois)</small>
                                </div>
                                 <div *ngIf="offer.id === 2">
                                   <small >(132.5 €/Mois)</small>
                                </div>
                                <div *ngIf="offer.id === 3">
                                   <small >(166 €/Mois)</small>
                                </div>
                              </div>
                            </div>
                             <div class="mb-5">
                              <ng-container *ngIf="offer.id === active_subscription_plan_id">
                                <!-- This is the current plan -->
                                <button class="btn btn-secondary w-100 mt-auto" disabled>Plan actuel</button>
                              </ng-container>
                              <ng-container *ngIf="offer.id !== active_subscription_plan_id">
                                <ng-container *ngIf="pending_plan_id == null">
                                  <!-- No pending plan change -->
                                  <button (click)="onSubmit(offer)" class="abonner btn btn-primary w-100 mt-auto"
                                  [disabled]="loading && offer.id === selectedOffer.id">
                                    <span *ngIf="!(loading && offer.id === selectedOffer.id)">S'abonner</span>
                                    <span *ngIf="loading && offer.id === selectedOffer.id">En cours...</span>
                                  </button>
                                </ng-container>
                                <ng-container *ngIf="pending_plan_id != null">
                                  <ng-container *ngIf="offer.id === pending_plan_id">
                                    <!-- This is the pending plan -->
                                    <button class="btn btn-warning w-100 mt-auto" disabled>Changement en attente</button>
                                  </ng-container>
                                  <ng-container *ngIf="offer.id !== pending_plan_id">
                                    <!-- Other offers, button disabled -->
                                    <button class="btn btn-primary w-100 mt-auto" disabled>S'abonner
                                    </button>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </div>


                            <!-- Pending Plan Message -->
                            <ng-container *ngIf="pending_plan_id != null && offer.id === pending_plan_id">
                              <div class="alert alert-info text-italic text-center mb-2">
                                Ce plan sera actif à la prochaine période de facturation.
                              </div>
                            </ng-container>

                            <!-- Features List -->
                            <div class="mb-4">
                              <div *ngFor="let feature of allFeatures" class="d-flex align-items-center mb-3">
                                <span class="fw-semibold text-gray-800 flex-grow-1 pe-2">
                                  {{ feature.description }}
                                  <ng-container *ngIf="isFeatureActive(offer, feature.id)">
                                    <ng-container *ngIf="getFeatureInOffer(offer, feature.id).pivot.metadata.max_usage">
                                      :
                                      {{
                                        getFeatureInOffer(offer, feature.id).pivot.metadata.max_usage === -1
                                          ? 'illimité'
                                          : getFeatureInOffer(offer, feature.id).pivot.metadata.max_usage
                                      }}
                                    </ng-container>
                                    <ng-container *ngIf="getFeatureInOffer(offer, feature.id).pivot.metadata.max_download">
                                      :
                                      {{
                                        getFeatureInOffer(offer, feature.id).pivot.metadata.max_download === -1
                                          ? 'illimité'
                                          : getFeatureInOffer(offer, feature.id).pivot.metadata.max_download
                                      }}
                                    </ng-container>
                                  </ng-container>
                                </span>

                                <!-- Checkmark or Cross Icon Based on Feature Availability -->
                                <ng-container *ngIf="isFeatureActive(offer, feature.id); else notActive">
                                  <i class="ki-duotone ki-check-circle text-success fs-5">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                  </i>
                                </ng-container>
                                <ng-template #notActive>
                                  <i class="ki-duotone ki-cross-circle fs-5">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                  </i>
                                </ng-template>
                              </div>
                            </div>

                           

                            <!-- Subscription Button -->
                           
                          </div>
                        </div>
                      </div>

                      <!-- No Offers Available Message -->
                      <div class="alert alert-warning text-center mt-5" role="alert"
                        *ngIf="listOffer && !listOffer.length">
                        <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                        <span class="empty-list">
                          La liste est vide
                        </span>
                      </div>
                    </div>

                    <!--end::Row-->
                  </div>
                  <!--end::Plans-->
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Pricing card-->
            </div>
            <!--end::Content container-->
          </div>


        </div>

      </div>
    </div>

  </div>

